import { render, staticRenderFns } from "./ProductTagDialog.vue?vue&type=template&id=3ec6ef3d&scoped=true&"
import script from "./ProductTagDialog.vue?vue&type=script&lang=js&"
export * from "./ProductTagDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagDialog.vue?vue&type=style&index=0&id=3ec6ef3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec6ef3d",
  null
  
)

export default component.exports